import { render } from "./SymptomReportView.vue?vue&type=template&id=799e79f6&scoped=true"
import script from "./SymptomReportView.vue?vue&type=script&lang=js"
export * from "./SymptomReportView.vue?vue&type=script&lang=js"

import "./SymptomReportView.vue?vue&type=style&index=0&id=799e79f6&lang=scss&scoped=true"
import "./SymptomReportView.vue?vue&type=style&index=1&id=799e79f6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799e79f6"]])

export default __exports__